<template>
  <div class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end">
      <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5" type="button" @click="createShow=true">
              <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
              <span class="p-l-20 p-r-10">Create Cookie</span>
          </button>
      </div>
  </div>
  <dataTable :name="'OperatorList'" ref="agGrid" :columnDefs="columnDefs" :data="data" @cellClicked="detailShow=$event.data"  @remove="remove"></dataTable>
  <detail v-if="detailShow!=null" :data="detailShow" @close="detailShow=null"></detail>
  <create v-if="createShow" @close="createShow=false" :id="id" @get="get(); $emit('get')"></create>
</template>

<script>
  import detail from "./detail";
  import create from "./create";
  export default {
    name: 'Operators',
    props:{
      id:Number
    },
    components:{detail,create},
    data(){
      return { 
        data:null,
        countries:[],
        countryId:228,
        columnDefs:[
          {"headerName":"Key","field":"Key","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {"headerName":"Items Count","field":"Items","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
            cellRenderer:function(params){
              return params.value.length
            }
          },
          {"headerName":"Extras","field":"Extras","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
            cellRenderer:function(params){
              return "<pre>"+JSON.stringify(params.value)+"</pre>"
            }
          },
          {"headerName":"Title","field":"Title","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {"headerName":"Proxy","field":"Proxy","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
            cellRenderer:function(params){
              return "<pre>"+JSON.stringify(params.value)+"</pre>"
            }
          },
          {"headerName":"Sessioner","field":"Sessioner","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
          {
              headerName: "",
              type:"action",
              width:40,
              buttons:[
                {
                  classes:"btn btn-xs waves-effect waves-light btn-danger",
                  text:'<i class="fas fa-trash-alt"></i>',
                  emit:"remove"
                }
              ],
              filter:false,
              sortable:false,
              resizable: false,
              floatingFilter: false,
              cellRenderer: this.$BtnCellRenderer,
              cellRendererParams: {
                clicked: function(field) {
                  this.$emit(field.emit,field.data)
                }
              }
            }
        ],
        detailShow:null,
        createShow:false
      }
    },
    created(){
      this.get();
    },
    methods:{
      get(){
        this.data=null;
        this.$appAxiosAdmin.get(`Operators/Cookies/`+this.id).then(response => {
          this.data=response.data;
          this.detail=this.data[0]
        });
      },
      remove(item){
          this.$swal({
              icon:"question",
              title:"Warning!",
              text:"Are you sure you want to delete the cookie?",
              showCancelButton:true,
              confirmButtonText:"Yes",
              cancelButtonText:"No"
          }).then(question=>{
              if(question.isConfirmed){
                  this.$appAxiosAdmin.delete(`Operators/Cookies/`+item.Key).then(() => {
                      this.$refs.agGrid.removeRow([item]);
                      this.$swal({
                          icon:"success",
                          title:"Success",
                          text:"The cookie has been successfully deleted.",
                          timer: 2000,
                          confirmButtonText:"Okey"
                      });
                      this.$emit("get");
                  }).catch(err=>{
                    this.$isError(err);
                  });
              }
          });
      }
    }
  }
</script>
